<template>
	<footer class="footer">
		<div class="container">


			<div class="copyright">
				
			</div>
			<div class="copyright text-center">
				<b>&copy; {{ new Date().getFullYear() }}</b> <b><span class="text-primary"> {{translate(locale.system)}}</span></b>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Layout/ContentFooter.vue